import styled, { css } from 'styled-components';

export const PlanInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  justify-content: center;

  h3 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 500;
  }

  > div {
    display: flex;
    gap: 32px;
  }
`;

export const PlanImg = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.grey[700]};
  border-radius: 8px;
  padding: 16px 28px;

  img {
    width: 100%;
    max-width: 48px;
    margin-bottom: 8px;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  padding: 60px 8px;
  border: 2px dotted ${({ theme }) => theme.colors.grey.white};
  cursor: pointer;

  ${({ $active }) =>
    $active &&
    css`
      background-color: ${({ theme }) => theme.colors.grey[700]};
    `}

  svg {
    width: 44px;
    height: 44px;
  }

  h3 {
    font-family: 'Bebas Neue', sans-serif;
  }

  &:hover {
    transition: 0.7s;
    background-color: ${({ theme }) => theme.colors.grey[700]};
  }
`;

export const UploadPreviewList = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const UploadItem = styled.div`
  width: 100%;
  max-width: 230px;
  display: flex;
  flex-direction: column;
  position: relative;

  button {
    width: fit-content;
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 100%;
    border: 1px solid ${({ theme }) => theme.colors.grey.black};
    background-color: ${({ theme }) => theme.colors.outher.danger};
    color: ${({ theme }) => theme.colors.grey.white};

    svg {
      width: 28px;
      height: 28px;
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.7;
    }
  }
`;

export const GaleryUploads = styled.section`
  width: 100%;
  margin-top: 20px;
  text-align: center;

  h2 {
    font-family: 'Bebas Neue', sans-serif;
  }
`;

export const GroupGaleryUploads = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
